<div class="login form-frame">
  <app-logo></app-logo>

  <form
    [formGroup]="form"
    (ngSubmit)="sendForm()"
    class="form-frame__body">
    <h2
      class="form-frame__body-title">
      {{'RESET_PASSWORD.TITLE' | translate}}
    </h2>
    <p
      class="form-frame__body-description">
      {{'RESET_PASSWORD.DESCRIPTION' | translate}}
    </p>

    <div class="form-frame__body-inputs">

      <div
        [class.error]="form.get('passwordFormControl')?.invalid && form.get('passwordFormControl')?.touched"
        class="input-block offset-bottom">
        <input
          formControlName="passwordFormControl"
          id="password"
          class="input"
          type="password"
          placeholder=" ">
        <label
          for="password"
          class="placeholder">
          {{'RESET_PASSWORD.NEW_PASSWORD' | translate}}
        </label>
        <ng-container *ngIf="form.get('passwordFormControl')?.invalid && form.get('passwordFormControl')?.touched">
          <span
            *ngIf="passwordRequiredError"
            class="input-block__error">
            {{'RESET_PASSWORD.PASSWORD_REQUIRED' | translate}}
          </span>
          <span
            *ngIf="!passwordRequiredError && passwordLetterFormatError"
            class="input-block__error">
            {{'RESET_PASSWORD.LETTER_SYMBOL' | translate}}
          </span>
          <span
            *ngIf="!passwordRequiredError && passwordLetterFormatError"
            class="input-block__error">
            {{'RESET_PASSWORD.LETTER_SYMBOL' | translate}}
          </span>
          <span
            *ngIf="!passwordRequiredError && !passwordLetterFormatError && passwordDigitalFormatError"
            class="input-block__error">
            {{'RESET_PASSWORD.DIGITAL_SYMBOL' | translate}}
          </span>
          <span
            *ngIf="!passwordRequiredError && !passwordLetterFormatError && !passwordDigitalFormatError && passwordSymbolFormatError"
            class="input-block__error">
            {{'RESET_PASSWORD.SPECIAL_SYMBOL' | translate}}
          </span>
        </ng-container>
      </div>

      <div
        [class.error]="form.get('passwordFormControlConfirm')?.touched"
        class="input-block">
        <input
          formControlName="passwordFormControlConfirm"
          id="passwordConfirm"
          class="input"
          type="password"
          placeholder=" ">
        <label
          for="passwordConfirm"
          class="placeholder">
          {{'RESET_PASSWORD.CONFIRM_PASSWORD' | translate}}
        </label>
        <ng-container *ngIf="form.get('passwordFormControlConfirm')?.touched">
          <span
            *ngIf="passwordConfirmError && !passwordConfirmRequiredError"
            class="input-block__error">
            {{'RESET_PASSWORD.NOT_CONFIRM' | translate}}
          </span>
          <span
            *ngIf="passwordConfirmRequiredError"
            class="input-block__error">
            {{'RESET_PASSWORD.PASSWORD_REQUIRED' | translate}}
          </span>
        </ng-container>
      </div>

      <button
        [disabled]="form.invalid || passwordConfirmError"
        type="submit"
        class="btn btn-accent">
        {{'RESET_PASSWORD.BUTTON' | translate}}
      </button>
    </div>
  </form>

  <app-lang-select></app-lang-select>
</div>

